import { Injectable } from "@angular/core";
import { HttpClient } from "@app/shared/services/http/http-client.service";
import { Observable } from "rxjs";

@Injectable()
export class LogsService {
  constructor(private http: HttpClient) {}

  getLogs(query: string, lookbackMinutes: number): Observable<any[]> {
    const encodedQuery = encodeURIComponent(query);
    const url = `api/AppInsights/logs?query=${encodedQuery}&lookbackMinutes=${lookbackMinutes}`;
    return this.http.get<any[]>(url);
  }
}


